import { TTintService } from '../types/service-cookie.type';

type TProps = {
  tintServices: TTintService[];
  color: string;
};

export const getTintServiceWithSelectedColorInServices = ({ tintServices, color }: TProps) =>
  tintServices.find(service => service.parameters.color === color);
